// ----------------------------------------------------------------------

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:960px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1280px)': {
      fontSize: pxToRem(lg),
    },
  };
}

const FONT_PRIMARY = 'Roboto';

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: '34px',
    fontSize: '28px !important',
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: '28px',
    fontSize: '24px !important',
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: '20px',
    fontSize: '16px !important',
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: '22px',
    fontSize: '14px !important',
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: '20px',
    fontSize: '14px',
  },
  subtitle2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: '14px',
    fontSize: '12px',
  },
  subtitle3: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    fontFamily: FONT_PRIMARY,
  },
  subtitle4: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    fontFamily: FONT_PRIMARY,
  },
  body1: {
    fontFamily: FONT_PRIMARY,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  body2: {
    fontFamily: FONT_PRIMARY,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body3: {
    fontFamily: FONT_PRIMARY,
    lineHeight: 22 / 14,
    fontSize: pxToRem(12),
  },
  display1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 300,
    fontSize: '60px !important',
    letterSpacing: '3px',
  },
  display2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 300,
    lineHeight: '56px',
    fontSize: '48px !important',
    letterSpacing: '0.05em',
  },
  display3: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 300,
    lineHeight: '40px',
    fontSize: '34px !important',
  },
  display4: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: '28px',
    fontSize: '24px !important',
  },
  display5: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: '23px',
    fontSize: '20px !important',
  },
  display6: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: '23px',
    fontSize: '18px !important',
  },
  text: {
    fontFamily: FONT_PRIMARY,
    lineHeight: 'normal',
    fontSize: '10px !important',
  },
  caption: {
    fontFamily: FONT_PRIMARY,
    lineHeight: '18px',
    fontSize: '12px !important',
    fontWeight: 400,
  },
  overline: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: 1.1,
    textTransform: 'uppercase',
  },
  button: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'capitalize',
  },
};

export default typography;
